export default __webpack_public_path__ + "src/assets/icn-jogging.0f1ba00925c84cf37f06b01d5071ee09.svg";